module.exports = __webpack_public_path__ + "img/mesa_l001c.b18048d6.png";